<template>
    <div class="business-nav">
        <div
            v-for="(name, i) in data.menuNames"
            class="business-nav-menu" @click="handleClick(name.name)"
            :class="{'business-nav-menu-selected': data.activeName == name.name}"
            :key="i"><img :src="name.icon" v-if="name.icon">{{ name.name }}</div>
    </div>
</template>

<script>
import { reactive } from 'vue'
const informationIcon0 = require('@/assets/img/information_0.png')
const informationIcon1 = require('@/assets/img/information_1.png')
const informationIcon2 = require('@/assets/img/information_2.png')
export default {
    name: "businessNav",
    props: {
        activeMenu: String
    },
    setup(props, {emit}) {
        const data = reactive({
            menuNames: [
                // {name: '数字商城', icon: informationIcon0},
                {name: '供求信息发布', icon: informationIcon1},
                {name: '我的发布', icon: informationIcon2}
            ],
            activeName: props.activeMenu
        })
        const handleClick = (name) => {
            data.activeName = name
            emit('navClick', data.activeName)
        }

        // watch(props, () => {
        //     data.activeName = props.activeMenu
        //     // console.log(data.activeName)
        // })
        return {
            informationIcon0,
            informationIcon1,
            informationIcon2,
            handleClick,
            data
        }
    },
}
</script>

<style scoped lang="stylus">
    .business-nav {
        width 100%
        padding 0 5%
        height 40px
        display flex
        flex-wrap nowrap
        justify-content center
        .business-nav-menu {
            padding 0 20px
            margin 0 10px
            //width 140px
            height 40px
            line-height 40px
            color #FFF
            background-color #C9AB31
            font-size 16px
            text-align center
            border-radius 8px
        }
        .business-nav-menu img {
            width 20px
            height 20px
            margin-right 5px
            position relative
            top -2px
        }
        .business-nav-menu-selected {
            background-color #F3D53D
        }
    }
</style>